export default "__VITE_ASSET__2QyN8FWS__"